import { CheckCircle2, Lock, ChevronRight } from "lucide-react";

const STEPS = [
  { id: 1, label: "Script & Clips", desc: "Generate and select video clips" },
  { id: 2, label: "Production", desc: "Create voiceover & avatar assets" },
  { id: 3, label: "Final Render", desc: "Review and assemble video" },
];

export const WorkflowStepper = ({ currentStep, onStepChange, stepStates }) => {
  return (
    <div className="flex items-center" data-testid="workflow-stepper">
      {STEPS.map((step, i) => {
        const state = stepStates[step.id] || "upcoming";
        const isActive = currentStep === step.id;
        const isCompleted = state === "completed";
        const isLocked = state === "locked";

        return (
          <div key={step.id} className="flex items-center">
            <button
              onClick={() => !isLocked && onStepChange(step.id)}
              disabled={isLocked}
              data-testid={`step-${step.id}`}
              className={`flex items-center gap-2.5 px-3.5 py-2 rounded-lg text-left transition-all duration-200 ${
                isActive
                  ? "bg-[#4D11F6] shadow-sm"
                  : isCompleted
                  ? "hover:bg-emerald-50/80 cursor-pointer"
                  : isLocked
                  ? "cursor-not-allowed opacity-50"
                  : "hover:bg-[#F3F3F9] cursor-pointer"
              }`}
            >
              {/* Step number circle */}
              <div className={`w-6 h-6 rounded-full flex items-center justify-center text-[11px] font-bold shrink-0 transition-colors duration-200 ${
                isActive
                  ? "bg-white text-[#4D11F6]"
                  : isCompleted
                  ? "bg-emerald-500 text-white"
                  : isLocked
                  ? "bg-[#E2E4E7] text-[#94969C]"
                  : "bg-[#E2E4E7] text-[#676970]"
              }`}>
                {isCompleted && !isActive ? <CheckCircle2 size={14} /> : step.id}
              </div>
              {/* Label */}
              <div className="hidden md:block">
                <p className={`text-xs font-semibold leading-tight ${
                  isActive ? "text-white" : isCompleted ? "text-emerald-700" : isLocked ? "text-[#D8D9DD]" : "text-[#676970]"
                }`}>{step.label}</p>
              </div>
            </button>
            {/* Connector */}
            {i < STEPS.length - 1 && (
              <div className="flex items-center mx-1">
                {isCompleted ? (
                  <ChevronRight size={14} className="text-emerald-400" />
                ) : (
                  <ChevronRight size={14} className="text-[#D8D9DD]" />
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
